import { useEffect } from 'react';
import { usePlanningStore } from '@/stores/planning';

export function PlanningModeBanner() {
  const createMode = usePlanningStore((s) => s.createMode);
  const exitCreateMode = usePlanningStore((s) => s.exitCreateMode);
  const scheduleProjectMode = usePlanningStore((s) => s.scheduleProjectMode);
  const exitScheduleProjectMode = usePlanningStore((s) => s.exitScheduleProjectMode);

  // Global Escape key listener
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        if (createMode) exitCreateMode();
        if (scheduleProjectMode) exitScheduleProjectMode();
      }
    }
    if (createMode || scheduleProjectMode) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [createMode, scheduleProjectMode, exitCreateMode, exitScheduleProjectMode]);

  if (scheduleProjectMode) {
    return (
      <div className="mx-4 lg:mx-8 mb-3 bg-blue-50 border border-blue-200 rounded-lg overflow-hidden">
        <div className="flex items-center gap-3">
          <div className="w-1.5 self-stretch bg-blue-500 shrink-0" />

          <div className="flex-1 min-w-0 py-2.5">
            <p className="text-sm font-bold text-td-navy truncate">
              {scheduleProjectMode.projectName}
              <span className="font-normal text-td-muted"> — {scheduleProjectMode.faseName}</span>
            </p>
            {scheduleProjectMode.address && (
              <p className="text-xs text-td-muted truncate mt-0.5">{scheduleProjectMode.address}</p>
            )}
          </div>

          <span className="text-xs text-blue-600 shrink-0">Klik op een cel om in te plannen</span>

          <button
            type="button"
            onClick={exitScheduleProjectMode}
            className="shrink-0 mr-3 px-3 py-1.5 text-xs font-semibold text-blue-800 border border-blue-300 rounded-lg hover:bg-blue-100 transition-colors"
          >
            Annuleren
          </button>
        </div>
      </div>
    );
  }

  if (createMode) {
    const isSticky = createMode.type === 'feestdag' || createMode.type === 'verlof';
    const label =
      createMode.type === 'feestdag'
        ? `${createMode.name || 'Feestdag'} inplannen — Klik op dagen`
        : createMode.type === 'verlof'
          ? 'Verlof inplannen — Klik op cellen'
          : `Vrije taak: ${createMode.name} — Klik op een cel`;

    return (
      <div className="mx-4 lg:mx-8 mb-3 bg-purple-50 border border-purple-200 rounded-lg overflow-hidden">
        <div className="flex items-center gap-3">
          <div className="w-1.5 self-stretch bg-purple-500 shrink-0" />

          <div className="flex-1 min-w-0 py-2.5">
            <p className="text-sm font-semibold text-purple-800">{label}</p>
          </div>

          {isSticky && (
            <button
              type="button"
              onClick={exitCreateMode}
              className="shrink-0 px-3 py-1.5 text-xs font-semibold text-purple-800 bg-purple-100 border border-purple-300 rounded-lg hover:bg-purple-200 transition-colors"
            >
              Klaar
            </button>
          )}
          <button
            type="button"
            onClick={exitCreateMode}
            className="shrink-0 mr-3 px-3 py-1.5 text-xs font-semibold text-purple-700 border border-purple-300 rounded-lg hover:bg-purple-100 transition-colors"
          >
            Annuleren
          </button>
        </div>
      </div>
    );
  }

  return null;
}
